import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { getBestImageUrl } from '../utils/imageUrl';

interface ContactImageModuleData {
  title?: string;
  image?: {
    url: string;
    alternativeText?: string;
  };
  altText?: string;
  description?: string;
  imageUrl?: string;
}

interface UseContactImageModuleReturn {
  data: ContactImageModuleData | null;
  loading: boolean;
  error: string | null;
}

export function useContactImageModule(): UseContactImageModuleReturn {
  const [data, setData] = useState<ContactImageModuleData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactImageModule = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await apiService.getContactImageModule();

        if (response) {
          // For Strapi Cloud, the data is directly on the response object
          const attrs: any = response;
          const imageField: any = attrs.image;

          let imageUrl = getBestImageUrl(imageField) || null;

          // Debug to help diagnose cases where nothing renders
          try {
            console.log('📸 Contact Image Module raw:', response);
            console.log('📸 Image field:', imageField);
            console.log('📸 Final imageUrl:', imageUrl);
          } catch (_) {}

          setData({
            title: attrs.title,
            image: imageField || undefined,
            altText: attrs.altText,
            description: attrs.description,
            imageUrl: imageUrl || undefined,
          });
        } else {
          console.log('📸 No contact image module data found');
          setData(null);
        }
      } catch (err) {
        console.error('Contact image module fetch failed:', err);
        setError(`Failed to load contact image: ${err}`);
      } finally {
        setLoading(false);
      }
    };

    fetchContactImageModule();
  }, []);

  return { data, loading, error };
} 